export const LABEL = "I'd like to save this payment method";
export const LABEL_OFF = "I don't want to save this payment method";
